import React, { useEffect, useState } from "react";
import {
  Section,
  MainWrapper,
  LeftSection,
  RightSection,
  LoginContainer,
  Heading,
  FormSection,
  InputField,
  CustomInput,
  CheckboxContainer,
  ForgotPassword,
  LoginButton,
  OtherLoginContainer,
  Text,
  SocialLoginButton,
  SocialButtons,
  LogoTextContainer,
  NewAccountSection,
  SignUpSpan,
  ErrorText,
} from "./index.styled";
import { ReactComponent as HideIcon } from "../../Assets/Icons/HideIcon.svg";
import { ReactComponent as ShowIcon } from "../../Assets/Icons/ShowIcon.svg";
import { ReactComponent as BigCircle } from "../../Assets/Icons/BigCircle.svg";
import { ReactComponent as MidCircle } from "../../Assets/Icons/MidCircle.svg";
import { ReactComponent as SmallCircle } from "../../Assets/Icons/SmallCircle.svg";
import { ReactComponent as ErrorInfo } from "../../Assets/Icons/ErrorInfo.svg";
import outlook from "../../Assets/Images/outlook.png";
import google from "../../Assets/Images/google.png";
import Dashboard from "../../Assets/Images/Dashboard.png";
import { loginUser } from "../../Redux/auth/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../App";
import { useSnack } from "../../Components/SnackBar";
import { viewSizeCalculator } from "../../utils";

const Auth = () => {
  const [userCreds, setUserCreds] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });
  const [touched, setTouched] = useState({
    username: false,
    password: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const { isAuth, isLoading, isError, loginSuccess } = useSelector(
    (store) => store.auth,
  );

  const dispatch = useDispatch();
  const snack = useSnack();
  const navigate = useNavigate();

  useEffect(() => {
    // Check for remembered credentials
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    const rememberedPassword = localStorage.getItem("rememberedPassword");

    if (rememberedUsername && rememberedPassword) {
      setUserCreds({
        username: rememberedUsername,
        password: rememberedPassword,
        rememberMe: true,
      });
    }

    if (isAuth) {
      navigate("/");
    }
  }, [isAuth, navigate]);

  const handleOnChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    setUserCreds((prev) => ({ ...prev, [name]: val }));

    // Validate on change only if the field has been touched
    if (touched[name]) {
      validateField(name, val);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";

    if (!value.trim()) {
      error = "This field is required";
    } else if (name === "password" && value.length < 6) {
      error = "Password must be at least 6 characters";
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Validate username
    if (!userCreds.username.trim()) {
      newErrors.username = "Username is required";
      isValid = false;
    }

    // Validate password
    if (!userCreds.password.trim()) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (userCreds.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleUserSignin = async (e) => {
    e.preventDefault();

    if (isButtonClicked) return;
    setIsButtonClicked(true);

    setTouched({
      username: true,
      password: true,
    });

    validateForm();

    try {
      const result = await dispatch(
        loginUser({
          username: userCreds.username,
          password: userCreds.password,
        }),
      );

      if (result && userCreds.rememberMe) {
        localStorage.setItem("rememberedUsername", userCreds.username);
        localStorage.setItem("rememberedPassword", userCreds.password);
      } else {
        localStorage.removeItem("rememberedUsername");
        localStorage.removeItem("rememberedPassword");
      }

      if (result) {
        navigate("/");
      }
    } catch (err) {
      console.error("Login error", err);
    } finally {
      setIsButtonClicked(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleUserSignin(e);
    }
  };

  const handleForgotPassword = () => {
    // Implement forgot password functionality
    // navigate("/forgot-password");
  };

  const handleSignUp = () => {
    navigate("/sign-up");
  };

  useEffect(() => {
  if (isError) {
    snack(
      "Incorrect username or password",
      "#F34D4D",
      "#FFFFFF"
    );
  }
}, [isError, snack]);

  const isFormFilled = () => {
    const { username, password } = userCreds;
    const allFieldsFilled = username && password ? false : true;
    return allFieldsFilled;
  };

  return (
    <MainWrapper>
      <LeftSection>
        <LoginContainer>
          <Heading>Welcome Back!</Heading>
          <FormSection>
            {/* Username */}
            <div>
              <InputField error={errors.username && touched.username}>
                <CustomInput
                  placeholder="Enter Username ⃰"
                  name="username"
                  value={userCreds.username}
                  onChange={handleOnChange}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                />
              </InputField>
              {errors.username && touched.username && (
                <ErrorText>
                  <ErrorInfo
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                  />
                  {errors.username}
                </ErrorText>
              )}
            </div>
            {/* password */}
            <div>
              <InputField error={errors.password && touched.password}>
                <CustomInput
                  placeholder="Enter Password ⃰"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={userCreds.password}
                  onChange={handleOnChange}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                />
                <div onClick={() => setShowPassword((prev) => !prev)}>
                  {showPassword ? (
                    <ShowIcon
                      title={"Show"}
                      cursor={"pointer"}
                      width={viewSizeCalculator(1.25)}
                      height={viewSizeCalculator(1)}
                    />
                  ) : (
                    <HideIcon
                      title={"Hide"}
                      cursor={"pointer"}
                      width={viewSizeCalculator(1.25)}
                      height={viewSizeCalculator(1.0625)}
                    />
                  )}
                </div>
              </InputField>
              {errors.password && touched.password && (
                <ErrorText>
                  <ErrorInfo
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                  />
                  {errors.password}
                </ErrorText>
              )}
            </div>
            <Section>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  label="remember_me"
                  name="rememberMe"
                  id="remember_me"
                  checked={userCreds.rememberMe}
                  onChange={handleOnChange}
                  style={{
                    cursor: "pointer",
                    accentColor: "#F96250",
                    width: viewSizeCalculator(0.875),
                    height: viewSizeCalculator(0.875),
                  }}
                />
                <label style={{ cursor: "pointer" }} htmlFor="remember_me">
                  Remember Me
                </label>
              </CheckboxContainer>
              <ForgotPassword onClick={handleForgotPassword}>
                Forgot Password?
              </ForgotPassword>
            </Section>
          </FormSection>
          <LoginButton
            onClick={handleUserSignin}
            disabled={isFormFilled()}
          >
            {isLoading ? "Logging in..." : "Log In"}
          </LoginButton>
          <OtherLoginContainer>
            <Text>Or login with</Text>
          </OtherLoginContainer>
          <SocialButtons>
            <SocialLoginButton>
              <LogoTextContainer>
                <img src={outlook} alt="outlook" />
                Outlook
              </LogoTextContainer>
            </SocialLoginButton>
            <SocialLoginButton>
              <LogoTextContainer>
                <img src={google} alt="google" />
                Google
              </LogoTextContainer>
            </SocialLoginButton>
          </SocialButtons>
          <NewAccountSection>
            <div>Don't have an account?</div>
            <SignUpSpan onClick={handleSignUp}>Sign Up</SignUpSpan>
          </NewAccountSection>
        </LoginContainer>
      </LeftSection>
      <RightSection>
        <img
          src={Dashboard}
          alt="dashboard"
          style={{
            height: viewSizeCalculator(38),
            position: "absolute",
            right: "0",
            zIndex: 100,
          }}
        />
        <SmallCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-1%",
            width: viewSizeCalculator(39),
            height: viewSizeCalculator(39.125),
          }}
        />
        <MidCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-10%",
            width: viewSizeCalculator(48.375),
            height: viewSizeCalculator(48.0625),
          }}
        />
        <BigCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-22%",
            width: viewSizeCalculator(60.4375),
            height: viewSizeCalculator(57.9375),
          }}
        />
      </RightSection>
    </MainWrapper>
  );
};

export default Auth;
